import React, { useEffect, useState } from "react";
import { NotificationsList } from "./Notifications.styles";
import IntlMessages from "@iso/components/utility/intlMessages";
import { userNotifications } from "../../services/account/api";

export default function () {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    getUserNotifications();
  }, []);

  const getUserNotifications = async () => {
    await userNotifications()
      .then((result) => {
        setNotifications([...result.data.data.reverse()]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const renderNotifications = (item) => (
    <li className={`notifications__item ${item.seen ? "" : ""}`}>
      <div>
        <h4>{item.message}</h4>
        <p>
          <b>From:</b> {item.origin} |{" "}
          {new Date(item.updated).toLocaleString("en-US")}
        </p>
      </div>
      <i>
        {item.seen ? (
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.06031 0.0952791C7.25087 -0.0317597 7.49913 -0.0317597 7.68969 0.0952791L14.4974 4.63374C14.6552 4.73896 14.75 4.91609 14.75 5.10577C14.75 5.29545 14.6552 5.47258 14.4974 5.5778L7.68969 10.1163C7.49913 10.2433 7.25087 10.2433 7.06031 10.1163L0.252622 5.5778C0.0947978 5.47258 0 5.29545 0 5.10577C0 4.91609 0.0947978 4.73896 0.252622 4.63374L7.06031 0.0952791ZM1.59004 5.10577L7.375 8.96241L13.16 5.10577L7.375 1.24913L1.59004 5.10577Z"
              fill="#6A6A6A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.567308 4.53845C0.880623 4.53845 1.13462 4.79244 1.13462 5.10576V12.6699C1.13462 12.9206 1.23423 13.1611 1.41155 13.3384C1.58887 13.5158 1.82936 13.6154 2.08013 13.6154H12.6699C12.9206 13.6154 13.1611 13.5158 13.3385 13.3384C13.5158 13.1611 13.6154 12.9206 13.6154 12.6699V5.10576C13.6154 4.79244 13.8694 4.53845 14.1827 4.53845C14.496 4.53845 14.75 4.79244 14.75 5.10576V12.6699C14.75 13.2215 14.5308 13.7506 14.1407 14.1407C13.7506 14.5308 13.2216 14.75 12.6699 14.75H2.08013C1.52844 14.75 0.999355 14.5308 0.609255 14.1407C0.219156 13.7506 0 13.2215 0 12.6699V5.10576C0 4.79244 0.253992 4.53845 0.567308 4.53845Z"
              fill="#6A6A6A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.50692 7.73025C5.72846 7.95179 5.72846 8.31099 5.50692 8.53254L0.968455 13.071C0.746907 13.2926 0.387708 13.2926 0.166161 13.071C-0.0553869 12.8495 -0.0553869 12.4903 0.166161 12.2687L4.70462 7.73025C4.92617 7.5087 5.28537 7.5087 5.50692 7.73025Z"
              fill="#6A6A6A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.24429 7.73025C9.46583 7.5087 9.82503 7.5087 10.0466 7.73025L14.585 12.2687C14.8066 12.4903 14.8066 12.8495 14.585 13.071C14.3635 13.2926 14.0043 13.2926 13.7827 13.071L9.24429 8.53254C9.02274 8.31099 9.02274 7.95179 9.24429 7.73025Z"
              fill="#6A6A6A"
            />
          </svg>
        ) : (
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.02513 5.07692C4.52949 5.07692 4.1277 5.47871 4.1277 5.97434V13.1538C4.1277 13.6494 4.52949 14.0512 5.02513 14.0512H15.0763C15.572 14.0512 15.9738 13.6494 15.9738 13.1538V5.97434C15.9738 5.47871 15.572 5.07692 15.0763 5.07692H5.02513ZM3.05078 5.97434C3.05078 4.88394 3.93473 4 5.02513 4H15.0763C16.1667 4 17.0507 4.88394 17.0507 5.97434V13.1538C17.0507 14.2442 16.1667 15.1281 15.0763 15.1281H5.02513C3.93473 15.1281 3.05078 14.2442 3.05078 13.1538V5.97434Z"
              fill="#6A6A6A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.14127 5.67562C3.30623 5.42819 3.64054 5.36132 3.88798 5.52628L10.0508 9.63482L16.2136 5.52628C16.461 5.36132 16.7953 5.42819 16.9603 5.67562C17.1253 5.92306 17.0584 6.25737 16.811 6.42233L10.3495 10.73C10.1686 10.8506 9.93297 10.8506 9.7521 10.73L3.29061 6.42233C3.04318 6.25737 2.97631 5.92306 3.14127 5.67562Z"
              fill="#6A6A6A"
            />
          </svg>
        )}
      </i>
    </li>
  );
  return (
    <div className="p-5 rounded-xl bg-white w-full shadow-sm">
      <span className="text-xl">
        <IntlMessages id="page.overview.notifications.title" />
      </span>
      <NotificationsList>
        <div className="notifications-header">
          <span>
            <IntlMessages id="page.overview.notifications.subtitle" />
          </span>
          <div></div>
        </div>
        <ul className="notifications">
          {notifications.map(renderNotifications)}
        </ul>
      </NotificationsList>
    </div>
  );
}
